import { gql } from '@apollo/client';

const blogListItemFields = `
    content
    date
    featuredImage {
        node {
            mediaItemUrl
            mimeType
        }
    }
    author {
        node {
            avatar {
                url
                default
                foundAvatar
            }
            firstName
            lastName
            name
        }  
    }
    id
    slug
    categories {
        edges {
            node {
                name
                slug
            }
        }
    }
    title
    excerpt
`;

export const FETCH_BLOGS = gql`
    query GetBlogs($first:Int,$last:Int,$after:String,$before:String, $category:String, $searchTerm: String) {
        posts(first:$first, last:$last, after:$after , before:$before, where: {categoryName: $category, search: $searchTerm}) {
            pageInfo {
                hasPreviousPage
                hasNextPage
                endCursor
                startCursor
            }
            nodes {
                ${blogListItemFields}
            }
        }
    }
`;


export const FETCH_FEATURED_BLOG = gql`
    query GetFeaturedBlog($tag:String) {
        posts(first: 1, where: {tag:$tag}) {
            edges {
                node {
                    ${blogListItemFields}
                }
            }
        }
    }
`;

export  const FETCH_ALL_CATEGORIES = gql`
    query GetAllCategories {
        categories {
            nodes {
                name
                slug
            }
        }
    }
`;


export const FETCH_BLOG_BY_SLUG =gql`
    query GetBlogDetails($slug: String) {
        postBy(slug: $slug) {
            id
            content
            title
            date
            featuredImage {
                node {
                    uri
                    link
                    sourceUrl
                }
            }
            author {
                node {
                    firstName
                    lastName
                    name
                    avatar {
                        url
                        default
                        foundAvatar
                    }
                    description
                }
            }
            categories {
                edges {
                    node {
                        name
                        slug
                    }
                }
            }
            tags {
               nodes {
                  id
                  name
               }
            }
        }
    }
`;

export const FETCH_RELATED_BLOGS = gql`
    query GetRelatedBlogsForCategories($categories: String) {
        posts(where: {categoryName: $categories}, first: 3) {
            nodes {
                categories {
                    edges {
                        node {
                            name
                            slug
                        }
                    }
                }
                title
                content
                id
                slug
                date
                excerpt
                author {
                    node {
                        name
                    }
                }
                featuredImage {
                    node {
                        sourceUrl
                    }
                }
            }
        }
    }
`;

export const FETCH_FIRST_12_BLOGS_SLUG = gql`
    query GetFirst12BlogSlugs {
        posts(first: 12) {
            nodes {
                slug
            }
        }
    }
`


export const FETCH_ALL_BLOGS_FOR_SITEMAP = `
    query Get_All_Blogs_For_Sitemap($first: Int) {
        posts(first:$first) {
            nodes {
                slug
                date
            }
        }
    }
`